const styles = {
  container: {
    padding: '0 20px',
  },
  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  tableSection: {
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '30px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  statusBadge: {
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 500,
    display: 'inline-block',
  },
  statusCompleted: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
  },
  statusRunning: {
    backgroundColor: '#e3f2fd',
    color: '#004578',
  },
  statusFailed: {
    backgroundColor: '#fce4ec',
    color: '#c62828',
  },
  detailCard: {
    background: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e8e8e8',
    marginBottom: '16px',
  },
  detailGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px',
    marginBottom: '16px',
  },
  detailItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  detailLabel: {
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#888',
    fontWeight: 500,
  },
  detailValue: {
    fontSize: '14px',
    color: '#333',
    fontWeight: 500,
  },
  metricsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: '12px',
    marginBottom: '20px',
  },
  metricBox: {
    background: '#f8f9fa',
    borderRadius: '6px',
    padding: '12px 16px',
    textAlign: 'center',
    border: '1px solid #e8e8e8',
  },
  metricBoxValue: {
    fontSize: '22px',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '2px',
  },
  metricBoxLabel: {
    fontSize: '11px',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  resultTableContainer: {
    overflowX: 'auto',
    marginTop: '12px',
  },
  resultTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12px',
    '& th': {
      padding: '8px 10px',
      textAlign: 'left',
      fontWeight: 600,
      color: '#555',
      borderBottom: '2px solid #e0e0e0',
      backgroundColor: '#f5f5f5',
      whiteSpace: 'nowrap',
    },
    '& td': {
      padding: '8px 10px',
      borderBottom: '1px solid #f0f0f0',
      color: '#444',
    },
    '& tr:hover td': {
      backgroundColor: '#f9f9f9',
    },
  },
  errorBox: {
    background: '#fff5f5',
    border: '1px solid #fed7d7',
    borderRadius: '6px',
    padding: '12px 16px',
    marginTop: '12px',
  },
  errorTitle: {
    color: '#c53030',
    fontSize: '13px',
    fontWeight: 600,
    marginBottom: '4px',
  },
  errorMessage: {
    color: '#742a2a',
    fontSize: '12px',
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
  filterBar: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    marginBottom: '16px',
    flexWrap: 'wrap',
  },
  actionButton: {
    backgroundColor: '#005795',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#004578',
      boxShadow: '0 2px 8px rgba(0, 87, 149, 0.3)'
    },
  },
}

export default styles
